import React from "react";
import { useStore } from "effector-react";
import {
  fetchMore,
  receiptForModalSelected,
  receiptSelected,
  tableState$,
} from "../../../../../models/receipt";
import {
  List,
  ListItem,
  ListRowSeller,
  ListRowSellerName,
  ListRowDate,
  LoadingContainer,
  NoData,
  ListRowFooter,
} from "./styled";
import { formatNumber } from "../../../../../utils/number";
import { formatDate } from "../../../../../utils/date";
import { Spinner } from "../../../../ui-kit/Spinner";
import { Button } from "../../../../ui-kit/Button";
import { Checkbox } from "../../../../ui-kit/Checkbox";
import { PartnerIconCell } from "../ReceiptTable/Cells/PartnerIconCell";
import { useTranslation } from "react-i18next";
import { Receipt } from "types/receipt";

export function TableList({ selectedRows }: { selectedRows: string[] }) {
  const { t } = useTranslation();
  const { data, lastPage, loading } = useStore(tableState$);

  function onSelect(key: string) {
    receiptSelected({ key });
  }

  const iconValue = (item: Receipt) => {
    if (item?.inn === "M919805Z043")
      return "/images/markets/logo_dom.png";
    if (item?.inn === "P252739V478")
      return "/images/markets/logo_vet.jpeg";

    return item?.logo || "";
  };

  return (
    <List>
      {data.map((item) => (
        <ListItem
          key={item.id}
          onClick={() => receiptForModalSelected(item.id)}
          selected={selectedRows.includes(item.id)}
        >
          <ListRowDate>
            <div>
              {formatDate(
                new Date(item.dateTime as string),
                "dd.MM.yyyy HH:mm"
              )}
            </div>
            <Checkbox
              round
              onClick={(e) => e.stopPropagation()}
              checked={selectedRows.includes(item.id)}
              onChange={() => onSelect(item.id)}
            />
          </ListRowDate>
          <ListRowSeller>
            <PartnerIconCell value={iconValue(item)} />
            <ListRowSellerName>
              {item.orgName && <div>{item.orgName}</div>}
              <div>
                {item.orgName === " "
                  ? t("Продавец не определен")
                  : item.orgName
                  ? item.orgName
                  : t("Продавец не определен")}
              </div>
            </ListRowSellerName>
          </ListRowSeller>
          <ListRowFooter>
            <div>{formatNumber(item.totalSum, 2, true)} &#8381;</div>
            <div>{t("ИНН продавца")} {item.inn}</div>
          </ListRowFooter>
        </ListItem>
      ))}

      {!lastPage && data.length > 0 && (
        <Button style={{ margin: "0 auto" }} onClick={() => fetchMore()}>
          {t("loadMore")}
        </Button>
      )}
      {!data.length && <NoData>{t("Нет данных")}</NoData>}

      {loading && (
        <LoadingContainer>
          <Spinner radius="20px" />
        </LoadingContainer>
      )}
    </List>
  );
}
